function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module autoformat/autoformat
 */
import blockAutoformatEditing from './blockautoformatediting';
import inlineAutoformatEditing from './inlineautoformatediting';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * Enables a set of predefined autoformatting actions.
 *
 * For a detailed overview, check the {@glink features/autoformat Autoformatting feature documentation}
 * and the {@glink api/autoformat package page}.
 *
 * @extends module:core/plugin~Plugin
 */

var Autoformat = /*#__PURE__*/function (_Plugin) {
  _inherits(Autoformat, _Plugin);

  var _super = _createSuper(Autoformat);

  function Autoformat() {
    _classCallCheck(this, Autoformat);

    return _super.apply(this, arguments);
  }

  _createClass(Autoformat, [{
    key: "afterInit",
    value:
    /**
     * @inheritDoc
     */
    function afterInit() {
      this._addListAutoformats();

      this._addBasicStylesAutoformats();

      this._addHeadingAutoformats();

      this._addBlockQuoteAutoformats();

      this._addCodeBlockAutoformats();
    }
    /**
     * Adds autoformatting related to the {@link module:list/list~List}.
     *
     * When typed:
     * - `* ` or `- ` &ndash; A paragraph will be changed to a bulleted list.
     * - `1. ` or `1) ` &ndash; A paragraph will be changed to a numbered list ("1" can be any digit or a list of digits).
     *
     * @private
     */

  }, {
    key: "_addListAutoformats",
    value: function _addListAutoformats() {
      var commands = this.editor.commands;

      if (commands.get('bulletedList')) {
        blockAutoformatEditing(this.editor, this, /^[*-]\s$/, 'bulletedList');
      }

      if (commands.get('numberedList')) {
        blockAutoformatEditing(this.editor, this, /^1[.|)]\s$/, 'numberedList');
      }
    }
    /**
     * Adds autoformatting related to the {@link module:basic-styles/bold~Bold},
     * {@link module:basic-styles/italic~Italic}, {@link module:basic-styles/code~Code}
     * and {@link module:basic-styles/strikethrough~Strikethrough}
     *
     * When typed:
     * - `**foobar**` &ndash; `**` characters are removed and `foobar` is set to bold,
     * - `__foobar__` &ndash; `__` characters are removed and `foobar` is set to bold,
     * - `*foobar*` &ndash; `*` characters are removed and `foobar` is set to italic,
     * - `_foobar_` &ndash; `_` characters are removed and `foobar` is set to italic,
     * - ``` `foobar` &ndash; ``` ` ``` characters are removed and `foobar` is set to code,
     * - `~~foobar~~` &ndash; `~~` characters are removed and `foobar` is set to strikethrough.
     *
     * @private
     */

  }, {
    key: "_addBasicStylesAutoformats",
    value: function _addBasicStylesAutoformats() {
      var commands = this.editor.commands;

      if (commands.get('bold')) {
        var boldCallback = getCallbackFunctionForInlineAutoformat(this.editor, 'bold');
        inlineAutoformatEditing(this.editor, this, /(\*\*)([^*]+)(\*\*)$/g, boldCallback);
        inlineAutoformatEditing(this.editor, this, /(__)([^_]+)(__)$/g, boldCallback);
      }

      if (commands.get('italic')) {
        var italicCallback = getCallbackFunctionForInlineAutoformat(this.editor, 'italic'); // The italic autoformatter cannot be triggered by the bold markers, so we need to check the
        // text before the pattern (e.g. `(?:^|[^\*])`).

        inlineAutoformatEditing(this.editor, this, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, italicCallback);
        inlineAutoformatEditing(this.editor, this, /(?:^|[^_])(_)([^_]+)(_)$/g, italicCallback);
      }

      if (commands.get('code')) {
        var codeCallback = getCallbackFunctionForInlineAutoformat(this.editor, 'code');
        inlineAutoformatEditing(this.editor, this, /(`)([^`]+)(`)$/g, codeCallback);
      }

      if (commands.get('strikethrough')) {
        var strikethroughCallback = getCallbackFunctionForInlineAutoformat(this.editor, 'strikethrough');
        inlineAutoformatEditing(this.editor, this, /(~~)([^~]+)(~~)$/g, strikethroughCallback);
      }
    }
    /**
     * Adds autoformatting related to {@link module:heading/heading~Heading}.
     *
     * It is using a number at the end of the command name to associate it with the proper trigger:
     *
     * * `heading` with value `heading1` will be executed when typing `#`,
     * * `heading` with value `heading2` will be executed when typing `##`,
     * * ... up to `heading6` and `######`.
     *
     * @private
     */

  }, {
    key: "_addHeadingAutoformats",
    value: function _addHeadingAutoformats() {
      var _this = this;

      var command = this.editor.commands.get('heading');

      if (command) {
        command.modelElements.filter(function (name) {
          return name.match(/^heading[1-6]$/);
        }).forEach(function (modelName) {
          var level = modelName[7];
          var pattern = new RegExp("^(#{".concat(level, "})\\s$"));
          blockAutoformatEditing(_this.editor, _this, pattern, function () {
            // Should only be active if command is enabled and heading style associated with pattern is inactive.
            if (!command.isEnabled || command.value === modelName) {
              return false;
            }

            _this.editor.execute('heading', {
              value: modelName
            });
          });
        });
      }
    }
    /**
     * Adds autoformatting related to {@link module:block-quote/blockquote~BlockQuote}.
     *
     * When typed:
     * * `> ` &ndash; A paragraph will be changed to a block quote.
     *
     * @private
     */

  }, {
    key: "_addBlockQuoteAutoformats",
    value: function _addBlockQuoteAutoformats() {
      if (this.editor.commands.get('blockQuote')) {
        blockAutoformatEditing(this.editor, this, /^>\s$/, 'blockQuote');
      }
    }
    /**
     * Adds autoformatting related to {@link module:code-block/codeblock~CodeBlock}.
     *
     * When typed:
     * - `` ``` `` &ndash; A paragraph will be changed to a code block.
     *
     * @private
     */

  }, {
    key: "_addCodeBlockAutoformats",
    value: function _addCodeBlockAutoformats() {
      if (this.editor.commands.get('codeBlock')) {
        blockAutoformatEditing(this.editor, this, /^```$/, 'codeBlock');
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'Autoformat';
    }
  }]);

  return Autoformat;
}(Plugin); // Helper function for getting `inlineAutoformatEditing` callbacks that checks if command is enabled.
//
// @param {module:core/editor/editor~Editor} editor
// @param {String} attributeKey
// @returns {Function}


export { Autoformat as default };

function getCallbackFunctionForInlineAutoformat(editor, attributeKey) {
  return function (writer, rangesToFormat) {
    var command = editor.commands.get(attributeKey);

    if (!command.isEnabled) {
      return false;
    }

    var validRanges = editor.model.schema.getValidRanges(rangesToFormat, attributeKey);

    var _iterator = _createForOfIteratorHelper(validRanges),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var range = _step.value;
        writer.setAttribute(attributeKey, true, range);
      } // After applying attribute to the text, remove given attribute from the selection.
      // This way user is able to type a text without attribute used by auto formatter.

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    writer.removeSelectionAttribute(attributeKey);
  };
}